import React, {useState} from 'react'
import RenderFields from "../../../common/ui/render-fields";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import _ from "lodash";
import {CAMPAIGN_FILTER_FIELDS, CAMPAIGN_INPUT_FIELDS} from "../../constants/campaign.constant";
import {PAGINATION_FIELD_LIST} from "../../../design/constants/design.constant";

const emptyFilterCriteria: any = {
    objective: 'EMPTY',
    status: 'EMPTY',
};
let allFilterFields = _.groupBy(CAMPAIGN_FILTER_FIELDS, 'group')['filter'];
allFilterFields = _.concat(allFilterFields, _.groupBy(PAGINATION_FIELD_LIST, 'group')['pagination']);
const defaultSelectedField = {name: 'objective', value: 'OUTCOME_TRAFFIC'};
const defaultPagination: any = {limit: '10'};

const CampaignFilters = ({filterCriteria, setFilterCriteria}) => {
    const [campaignFilterFields, setCampaignFilterFields] = useState(prepareInputFields(allFilterFields, defaultSelectedField, filterCriteria));
    const [pagination, setPagination] = useState(defaultPagination);

    const handleFilterChanges = (event) => {
        const existingFilterCriteria = {...filterCriteria};

        const {name} = event.target;
        if (name === 'type') {
            const newFields = prepareInputFields(allFilterFields, event.target, existingFilterCriteria);
            setCampaignFilterFields(newFields);
        }

        handleFieldValueChanges(event, existingFilterCriteria, setFilterCriteria);
    }

    const clearFilterCriteria = () => {
        setFilterCriteria(emptyFilterCriteria);
    }

    return (
        <>
            <div className="flex flex-wrap justify-start w-full">
                <RenderFields
                    parentForm={filterCriteria}
                    handleDetailChanges={handleFilterChanges}
                    fieldList={campaignFilterFields}
                    enableEdit={true}
                    fieldClassName={`mr-2`}/>

                <div className="w-40">
                    <button
                        onClick={() => clearFilterCriteria()}
                        className="button-gray-outline mt-10 px-2 py-1">
                        Clear Filters
                    </button>
                </div>
            </div>
        </>
    )
}

export default CampaignFilters
